import {
    FaMobileAlt,
    FaUserCircle,
    FaMapPin,
    FaArrowsAlt,
    FaMicrochip,
    FaLightbulb
} from 'react-icons/fa';

const features = [
    {
        name: 'No Hardware Required',
        description: 'Use the devices your team already has—no need to invest in additional hardware.',
        icon: FaMobileAlt,
    },
    {
        name: 'Facial Recognition',
        description: 'Advanced computer vision ensures accurate, and fraud-free attendance reports.',
        icon: FaUserCircle,
    },
    {
        name: 'Precise Geolocation',
        description: 'Workers must be on-site for accurate attendance tracking.',
        icon: FaMapPin,
    },
    {
        name: 'Seamless Scalability',
        description: 'Easily scale across teams, projects, and locations without complex setup or hidden costs.',
        icon: FaArrowsAlt,
    },
    {
        name: 'Effortless Integration',
        description: 'Seamlessly integrates with other tools for a complete workforce management solution.',
        icon: FaMicrochip,
    },
    {
        name: 'Future-Ready Tech',
        description: 'Stay ahead with cutting-edge technology designed to evolve and adapt to your business needs.',
        icon: FaLightbulb,
    },
];

export default function FacialRecognitionSolutionEnhanced() {
    return (
        <section className="bg-surface py-20 sm:py-24">
            <div className="mx-auto max-w-6xl px-6">
                <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
                    <div>
                        <p className="text-eyebrow uppercase text-brand">
                            Facial Recognition Solution
                        </p>
                        <h2 className="mt-4 text-3xl font-semibold tracking-tight text-ink sm:text-4xl">
                            Accurate tracking without changing how crews work.
                        </h2>
                        <p className="mt-5 text-base leading-7 text-ink-2">
                            Leverage computer vision directly on your existing devices.
                        </p>

                        <dl className="mt-10 grid gap-4 sm:grid-cols-2">
                            {features.map((feature) => (
                                <div key={feature.name} className="rounded-2xl border border-border bg-surface-2 p-4">
                                    <dt className="flex items-center gap-3 text-sm font-semibold text-ink">
                                        <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-brand/10 text-brand">
                                            <feature.icon className="h-4 w-4" aria-hidden="true" />
                                        </div>
                                        {feature.name}
                                    </dt>
                                    <dd className="mt-2 text-sm leading-6 text-ink-3">
                                        {feature.description}
                                    </dd>
                                </div>
                            ))}
                        </dl>
                    </div>

                    <div className="flex items-center justify-center lg:justify-end">
                        <img
                            src="/facialRecog-nobg.png"
                            alt="Facial Recognition Mobile App Interface"
                            className="w-full max-w-md rounded-3xl border border-border bg-surface p-3 shadow-[0_20px_80px_rgba(28,25,23,0.08)]"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
}
